module.exports = __webpack_public_path__ + "static/casque4-129a0f13b8bd3f82e251271625311902.jpg";